module.exports = __webpack_public_path__ + "img/40.7e348eab.svg";